import axiosJava from "@/api/config_java";

//FB账户操作申请记录列表
export const accountDoApplyList = param =>
  axiosJava.get(`/am/api/accountOperate/list`, { params: param });

//账号操作列表重新提交
export const accountReApply = param =>
  axiosJava.post(`/am/api/accountOperate/add`, param);

//FB账户操作申请详情
export const accountReApplyDetail = (id) =>
  axiosJava.get(`/am/api/accountOperate/details?id=${id}`);